var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCircleNotch = function SvgIconCircleNotch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.16 3.399a1 1 0 0 1-.493 1.326 8 8 0 1 0 6.666 0 1 1 0 1 1 .834-1.818 10 10 0 1 1-8.334 0 1 1 0 0 1 1.326.492"
  })));
};
export default SvgIconCircleNotch;